import { useTranslation } from "react-i18next";

export const useColumnImportSummaryDefs =()=>{
  const {t}=useTranslation()
  return [
  {
    cellRenderer: "rowNumber",
    			comparator: () => 0,
    field: "rowNumber",
    type:"rowNumberType",
    headerName: t("pages.importHistory.importRecords.columnDetails.column1"),
    sortable: true,
    unSortIcon: true,
    
  },
  {
    			comparator: () => 0,
    field: "status",
    type:"statusType",
    headerName: t("pages.importHistory.importRecords.columnDetails.column2"),
    sortable: true,
    unSortIcon: true,
    cellRenderer: function (params:any) {
      return params.data.status === 0 ? t("pages.importHistory.importRecords.failed") :
             params.data.status === 1 ? t("pages.importHistory.importRecords.success") :
             "-"; 
    },
    
  },
  {
    			comparator: () => 0,
    field: "errorMessage",
    type:"errorMessageType",
    headerName: t("pages.importHistory.importRecords.columnDetails.column3"),
    flex: 1,
    sortable: true,
    unSortIcon: true,
    cellRenderer: function (params: any) {
      return <div className="text-wrap ">{params.data.errorMessage}</div>;
    },
    wrapText: true,
    autoHeight: true,
    cellClass:"overFlowWrapAnywhere"
  },
]};
